<template>
  <section class="input-field col" :class="size">
    <input :id="id"
           type="text"
           class="autocomplete"
           :disabled="disabled"
           :placeholder="watermark"
           @keyup.enter="$emit('searched', $event.target.value)"
    >
    <label class="active" :for="id">{{ name }}</label>
    <span class="helper-text left teal-text text-lighten-3" v-if="!disabled">
      <strong>Type and hit "Enter"</strong>
    </span>
  </section>
</template>

<script>
export default {
  /**
   * Difference between LookAhead.vue and Autocomplete.vue: The LookAhead doesn't know its list of
   * picks until you hit Enter, upon which the "searched()" event should fetch a new list of data
   * and mutate the "picks" prop, which will react and reopen the dropdown with new selections.
  */
  name: 'LookAhead',
  components: {},
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: true,
      validator(value) {
        return ['s1', 's2', 's3', 's4', 's5', 's6', 's7', 's8', 's9', 's10', 's11', 's12'].includes(value);
      },
    },
    picks: {
      type: Array,
      required: true,
    },
    watermark: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    limit: {
      type: Number,
      required: false,
      default: 100,
    },
  },
  data() {
    return {
      instance: null,
    };
  },
  computed: {
    mPicks() {
      const picksObj = {};
      this.picks.forEach(elem => {
        if (typeof elem === 'string' || typeof elem === 'number') {
          picksObj[elem] = null;
        } else {
          picksObj[elem.key] = elem.val;
        }
      });
      return picksObj;
    },
  },
  watch: {
    mPicks() {
      this.instance.updateData(this.mPicks);
      this.instance.open();
    },
  },
  methods: {},
  mounted() {
    const vm = this;
    this.instance = this.materialize.Autocomplete.init(document.getElementById(this.id), {
      data: this.mPicks,
      limit: this.limit,
      minLength: 1,
      onAutocomplete(val) {
        const elem = this.$el[0];
        const choice = elem.value;
        vm.$emit('picked', choice, elem);
      },
    });
  },
};
</script>
